export const isInAppWebView = () => {
  const ua = navigator.userAgent || '';

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);

  const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS/.test(ua);
  const isChrome = /Chrome|CriOS/i.test(ua);
  const isFirefox = /Firefox/i.test(ua);
  const isEdge = /Edg/i.test(ua);

  // iOS WebView: Safari not present, but it's still iOS
  if (isIOS) {
    const isWebview = !isSafari && !isChrome && !isFirefox && !isEdge;
    return isWebview;
  }

  // Android WebView: 'wv' or missing Chrome
  if (isAndroid) {
    const isWebview = /wv/.test(ua) || (!isChrome && !isFirefox && !isEdge);
    return isWebview;
  }

  // Desktop or unrecognized
  return false;
};
